// extracted by mini-css-extract-plugin
export default {"pageTitle":"NewMember_pageTitle__TaoTh","status":"NewMember_status__-SPW-"};